import css from 'styled-jsx/css';

const staticStyles = css.global`
  @import 'src/common/styling/_mixins-scss/rem';

  .SliderField {
    margin: rem(-5px 0 34px);
  }

  .SliderField__limits {
    display: flex;
    justify-content: space-between;
    color: #777777;
    font-size: rem(12px);
    margin-bottom: rem(3px);
  }

  .SliderField__control {
    position: relative;
    height: rem(32px);
  }

  .SliderField__input {
    appearance: none;
    border: 0;
    border-radius: rem(4px);
    cursor: pointer;
    height: rem(5px);
    margin: rem(7px 0 0);
    outline: none;
    padding: 0;
    transition: none;
    width: 100%;

    &:disabled {
      cursor: default;
      opacity: 0.6;
    }

    &::-webkit-slider-thumb {
      appearance: none;
      background: #ffffff;
      border: 1px solid #c5c5c5;
      border-radius: 50%;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
      height: rem(18px);
      width: rem(18px);
    }

    &::-moz-range-thumb {
      background: #ffffff;
      border: 1px solid #c5c5c5;
      border-radius: 50%;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
      height: rem(18px);
      width: rem(18px);
    }
  }

  .SliderField__value {
    border-radius: rem(3px);
    color: #ffffff;
    font-size: rem(12px);
    padding: rem(4px 7px);
    position: absolute;
    top: rem(24px);
    transform: translateX(-50%);
    white-space: nowrap;
    z-index: 3;
  }
`;

export { staticStyles };
